<template>
  <div v-show="isShow">
    <div class="widget-button" @click="expand">
      <div class="new-message-number" v-show="totalUnseenMessages > 0">{{ totalUnseenMessages }}</div>
      <div class="button-chat color-theme-default">
        <div class="button-chat-icon open-widget">
          <img style="max-width: 36px;" src="../../assets/img/subiz.svg" alt="">
        </div>
      </div>
    </div>
    <div class="widget_body preview" v-if="showPreview">
      <div class="widget-preview-close" @click.stop="closePreview(lastUnseenMessage.created)">
        <v-icon name="times-circle" scale="1.2" :fill="themeColor"/>
      </div>
      <div class="widget-header color-theme-default" @click="expand">
        <div class="widget-header-content">
          <div class="widget-preview-title">
            <h4>{{lastUnseenMessage.agentInfo.fullname || ''}}</h4>
            <p style="overflow-wrap: break-word; padding-right: 5px;">{{ lastUnseenMessage.text | removeMarkdown | truncate(50, '...', ' ') }}</p>
          </div>
          <div class="widget-preview-avatar">
            <img :src="lastUnseenMessage.avatarURL || $store.state.defaultAvatar" alt="">
          </div>
        </div>
      </div>
      <div class="widget-footer" id="widget-footer">
        <div class="type-message">
          <div id="message">
            <textarea :placeholder="$t('reply')" class="keyup" id="msg" ref="messageInput" v-model="message" @keydown.enter.exact.prevent="sendMessage"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Client, Server } from '../client_server.js'
import eventHub from '../lib/hub'
import * as utils from '../utils'
import bowser from 'bowser'
import { mapGetters, mapState } from 'vuex'
import * as types from '../store/mutation_types'
import store from '../store'
import router from '../router'
import storage from '../lib/storage'
const objectPath = require('object-path')
const g_client = new Client('widget_4_parent', window.parent)

export default {
  name: 'chat-button',

  data () {
    return {
      lastPreviewTime: '',
      isShow: true,
      message: ''
    }
  },

  computed: {
    ...mapState([
      'conversations',
      'accountId',
      'cssReady',
      'userId',
      'accountId',
      'lastConvoId',
      'convoListReady',
      'convoEvents',
      'themeColor'
    ]),

    ...mapGetters([
      'countUnseenMessageByConvoId',
      'lastUnseenMessage'
    ]),

    totalUnseenMessages () {
      return this.countUnseenMessageByConvoId(this.lastUnseenMessage.convoId)
    },

    ready () {
      return this.cssReady
    },

    showPreview () {
      const messageText = objectPath.get(this.lastUnseenMessage, 'text')
      if ((utils.getMs(this.lastUnseenMessage.created) <= utils.getMs(this.lastPreviewTime)) ||
        bowser.mobile || !messageText) {
        return false
      }
      return true
    }
  },

  async created () {
				this.lastPreviewTime =await storage.get('preview_message_time', '')
    // tự động mở cửa sổ chat trên desktop khi có conversation mới
    eventHub.$on('widget.conversation_added', this.handleWidgetConversationAdded)
    eventHub.$on('widget.hide_chat_button', () => {
      utils.log('event: hide_chat_button')
      this.isShow = false
    })

    eventHub.$on('widget.show_chat_button', () => {
      utils.log('event: show_chat_button')
      this.isShow = true
    })
  },

  beforeDestroy () {
    eventHub.$off('widget.conversation_added', this.handleWidgetConversationAdded)
  },

  methods: {
	  async sendMessage () {
      let convoId = this.lastUnseenMessage.convoId
      let messageText = this.message.trim()
      utils.log('send Message:', messageText)

      let isValid = this.validateMessage(this.conversations, messageText, convoId)
      if (!isValid) return

      eventHub.$emit('widget.message_sending', true)
      utils.sendEventToThirdParty(g_client, 'SUBIZ Chat', 'Sent', 'User')

      const accountId = this.accountId
      const userId = this.userId

      if (!convoId) {
        const convo = await this.$store.dispatch('startConversation', { accountId, userId })
        convoId = convo.id
      }

      const message = {
        account_id: accountId,
        type: 'message_sent',
        object: 'message',
        data: {
          message: {
            text: messageText,
            format: 'plaintext'
          }
        }
      }

      await this.$store.dispatch('sendMessage', { accountId, convoId, message })

      eventHub.$emit('widget.message_sending', false)
      eventHub.$emit('widget.message_sent')

      const input = this.$refs.messageInput
      if (!bowser.mobile) {
        input.focus()
      }

      if (convoId) {
        this.$router.push({ name: 'convo', params: { convoId } })
      }
    },

    validateMessage (conversations, messageText, convoId) {
      const convo = conversations.find(c => c.id === convoId)
      messageText = messageText.trim()
      if (!messageText || convo.state === 'ended') {
        return false
      }

      // reset input
      this.message = ''
      const input = this.$refs.messageInput
      if (bowser.mobile || !convoId) {
        input.blur()
      }

      return true
    },

    expand (event) {
		  eventHub.$emit('widget.expand')
    },

    closePreview (time) {
      this.lastPreviewTime = time
      storage.set('preview_message_time', time, 86400)
    },

    async handleWidgetConversationAdded (convoId) {
      const isClosed = await storage.get('is_closed', false)
      if (!bowser.mobile && !bowser.tablet && !isClosed) {
        utils.sendEventToThirdParty(g_client, 'SUBIZ Chat', 'Opened', 'Subiz Windows')
        this.$router.push({ name: 'convo', params: { convoId } })
      }
    },
  },

  watch: {
    lastUnseenMessage (message) {
      if (message.text === '') return

      let convoId = objectPath.get(message, 'convoId', '')
      let events = objectPath.get(this.convoEvents, convoId, [])
      events = utils.orderBy(events, 'created', 'asc')
      let sentMessages = events.filter(event => event.type === 'message_sent')
      let firstMessage = objectPath.get(sentMessages, '0', '')
      if (firstMessage && firstMessage.id === message.id) {
				// await this.handleWidgetConversationAdded(convoId)
        eventHub.$emit('widget.conversation_added', convoId)
      }
      this.$store.commit(types.SET_LAST_CONVO_ID, convoId)
      eventHub.$emit('widget.ui_changed', 'convolist210' )
    },

    ready (ready) {
      if (!ready) return
      utils.log('button chat ready')

      eventHub.$emit('widget.ui_changed' ,'convolist217' )
      eventHub.$emit('widget.show_iframe')
    }
  },

  filters: {
    removeMarkdown: utils.removeMarkdown
  },

updated() {
		      eventHub.$emit('widget.ui_changed' ,'chatbutton114' )
		},
}
</script>
